// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.propertycondition.RentalManagerPropertyConditionWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  CancelSigningRequestDto,
  CreatePropertyConditionAssociationRequestDto,
  CreatePropertyConditionFieldDataRequestDto,
  CreatePropertyConditionRequestDto,
  CreatePropertyConditionUserAcceptanceRequestDto,
  CreatePropertyConditionUsersRequestDto,
  CreatePropertyItemRequestDto,
  CreatePropertyItemResponseDto,
  GetAllPropertyComponentTypesResponseDto,
  GetAllPropertyItemTypesResponseDto,
  GetItemImagesResponseDto,
  GetItemUploadTokenResponseDto,
  GetLeasesResponseDto,
  GetListingAddressResponseDto,
  GetNotedConditionRequestDto,
  GetNotedConditionsResponseDto,
  GetPropertyComponentQuantityResponseDto,
  GetPropertyComponentsResponseDto,
  GetPropertyConditionAssociationsResponseDto,
  GetPropertyConditionFeatureFlagsResponseDto,
  GetPropertyConditionFieldsDataResponseDto,
  GetPropertyConditionFieldsResponseDto,
  GetPropertyConditionResponseDto,
  GetPropertyConditionsResponseDto,
  GetPropertyItemAttributesResponseDto,
  GetPropertyItemEntitiesResponseDto,
  GetPropertyItemResponseDto,
  GetPropertyItemsResponseDto,
  ItemAttributeConditionTypesResponseDto,
  ListingAlias,
  PropertyConditionAssociationDto,
  PropertyConditionDocumentPreviewResponseDto,
  PropertyConditionEmptyResponse,
  PropertyConditionFieldDataDto,
  PropertyConditionPhase,
  PropertyConditionUserAcceptanceDto,
  PropertyConditionUserAcceptancesResponseDto,
  PropertyConditionUsersResponseDto,
  PropertyConditionWaitlistResponseDto,
  SendForSigningRequestDto,
  StoreItemEntitiesRequestDto,
  UpdatePropertyComponentQuantityRequestDto,
  UpdatePropertyConditionFieldDataRequestDto,
  UpdatePropertyConditionRequestDto,
  UpdatePropertyConditionUserAcceptancesRequestDto,
  UpdatePropertyConditionUsersRequestDto,
} from '../..';

interface AddToPropertyConditionWaitlistParams {
  listingAlias: ListingAlias;
}
interface GetIsOnPropertyConditionWaitlistParams {
  listingAlias: ListingAlias;
}
interface GetItemAttributesParams {
  propertyItemId: number;
}
interface GetItemImagesParams {
  propertyItemId: number;
}
interface GetLeasesParams {
  listingAlias: ListingAlias;
}
interface GetListingAddressParams {
  listingAlias?: string;
  propertyConditionId?: number;
}
interface GetNotedConditionsParams {
  imagesPerItemLimit?: number;
  overridePropertyConditionPhase?: PropertyConditionPhase;
  propertyConditionId: number;
}
interface GetPropertyComponentItemParams {
  includeItemAttributes?: boolean;
  includeItemImages?: boolean;
  includeItemLatestActivity?: boolean;
  propertyItemId: number;
}
interface GetPropertyComponentQuantityParams {
  propertyConditionId: number;
}
interface GetPropertyComponentsForPropertyConditionParams {
  includeItemAttributes?: boolean;
  includeItemImages?: boolean;
  includeItemLatestActivity?: boolean;
  includeItems?: boolean;
  propertyConditionId: number;
}
interface GetPropertyConditionParams {
  includeAssociations?: boolean;
  includeFieldsData?: boolean;
  includePreviousPhasesData?: boolean;
  includeSigningParticipants?: boolean;
  includeWizard?: boolean;
  propertyConditionId: number;
}
interface GetPropertyConditionAssociationsParams {
  propertyConditionId: number;
}
interface GetPropertyConditionDocumentPreviewParams {
  propertyConditionId: number;
}
interface GetPropertyConditionFieldsDataParams {
  filterFieldDataBy?: string;
  propertyConditionId: number;
}
interface GetPropertyConditionsParams {
  filterPropertyConditionLifecycleBy?: string;
  includeAssociations?: boolean;
  includeFieldsData?: boolean;
  includePreviousPhasesData?: boolean;
  includeSigningParticipants?: boolean;
  listingAlias?: string;
}
interface GetPropertyConditionUserAcceptancesParams {
  propertyConditionId: number;
}
interface GetPropertyConditionUsersParams {
  filterUserRoleBy?: string;
  propertyConditionId: number;
}
interface GetUploadTokenParams {
  propertyItemId: number;
}
interface MarkAsSignedParams {
  propertyConditionId: number;
}
interface MarkItemsConditionParams {
  itemAttributeConditionType: string;
  propertyComponentId?: number;
  propertyConditionId?: number;
  propertyItemId?: number;
}
interface RemoveItemImageParams {
  propertyItemImageId: number;
}
interface RemovePropertyConditionAssociationParams {
  propertyConditionId: number;
}
interface RemovePropertyConditionUserParams {
  propertyConditionUserId: number;
}
interface RemovePropertyItemParams {
  itemVersion?: number;
  override?: boolean;
  propertyItemId: number;
}

export const RentalManagerPropertyConditionWebApiHandler_addToPropertyConditionWaitlist_Path =
  '/api/web/v1/users/propertyCondition/addToPropertyConditionWaitlist';

export const RentalManagerPropertyConditionWebApiHandler_addToPropertyConditionWaitlist = (
  getParams: AddToPropertyConditionWaitlistParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<AddToPropertyConditionWaitlistParams, never, PropertyConditionWaitlistResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_addToPropertyConditionWaitlist_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_cancelSigning_Path =
  '/api/web/v1/users/propertyCondition/cancelSigning';

export const RentalManagerPropertyConditionWebApiHandler_cancelSigning = (
  postData: CancelSigningRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, CancelSigningRequestDto, PropertyConditionEmptyResponse>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_cancelSigning_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_createPropertyCondition_Path =
  '/api/web/v1/users/propertyCondition/createPropertyCondition';

export const RentalManagerPropertyConditionWebApiHandler_createPropertyCondition = (
  postData: CreatePropertyConditionRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, CreatePropertyConditionRequestDto, GetPropertyConditionResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_createPropertyCondition_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_createPropertyConditionAssociation_Path =
  '/api/web/v1/users/propertyCondition/createPropertyConditionAssociation';

export const RentalManagerPropertyConditionWebApiHandler_createPropertyConditionAssociation = (
  postData: CreatePropertyConditionAssociationRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, CreatePropertyConditionAssociationRequestDto, PropertyConditionAssociationDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_createPropertyConditionAssociation_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_createPropertyConditionFieldData_Path =
  '/api/web/v1/users/propertyCondition/createPropertyConditionFieldData';

export const RentalManagerPropertyConditionWebApiHandler_createPropertyConditionFieldData = (
  postData: CreatePropertyConditionFieldDataRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, CreatePropertyConditionFieldDataRequestDto, PropertyConditionFieldDataDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_createPropertyConditionFieldData_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_createPropertyConditionUserAcceptance_Path =
  '/api/web/v1/users/propertyCondition/createPropertyConditionUserAcceptance';

export const RentalManagerPropertyConditionWebApiHandler_createPropertyConditionUserAcceptance = (
  postData: CreatePropertyConditionUserAcceptanceRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, CreatePropertyConditionUserAcceptanceRequestDto, PropertyConditionUserAcceptanceDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_createPropertyConditionUserAcceptance_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_createPropertyConditionUsers_Path =
  '/api/web/v1/users/propertyCondition/createPropertyConditionUsers';

export const RentalManagerPropertyConditionWebApiHandler_createPropertyConditionUsers = (
  postData: CreatePropertyConditionUsersRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, CreatePropertyConditionUsersRequestDto, PropertyConditionUsersResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_createPropertyConditionUsers_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_createPropertyItem_Path =
  '/api/web/v1/users/propertyCondition/createPropertyItem';

export const RentalManagerPropertyConditionWebApiHandler_createPropertyItem = (
  postData: CreatePropertyItemRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, CreatePropertyItemRequestDto, CreatePropertyItemResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_createPropertyItem_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getAllPropertyComponentTypes_Path =
  '/api/web/v1/users/propertyCondition/getAllPropertyComponentTypes';

export const RentalManagerPropertyConditionWebApiHandler_getAllPropertyComponentTypes = (
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, never, GetAllPropertyComponentTypesResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_getAllPropertyComponentTypes_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getAllPropertyItemTypes_Path =
  '/api/web/v1/users/propertyCondition/getAllPropertyItemTypes';

export const RentalManagerPropertyConditionWebApiHandler_getAllPropertyItemTypes = (
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, never, GetAllPropertyItemTypesResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_getAllPropertyItemTypes_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getIsOnPropertyConditionWaitlist_Path =
  '/api/web/v1/users/propertyCondition/getIsOnPropertyConditionWaitlist';

export const RentalManagerPropertyConditionWebApiHandler_getIsOnPropertyConditionWaitlist = (
  getParams: GetIsOnPropertyConditionWaitlistParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetIsOnPropertyConditionWaitlistParams, never, PropertyConditionWaitlistResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getIsOnPropertyConditionWaitlist_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getItemAttributeConditionTypes_Path =
  '/api/web/v1/users/propertyCondition/getItemAttributeConditionTypes';

export const RentalManagerPropertyConditionWebApiHandler_getItemAttributeConditionTypes = (
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, never, ItemAttributeConditionTypesResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_getItemAttributeConditionTypes_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getItemAttributes_Path =
  '/api/web/v1/users/propertyCondition/getItemAttributes';

export const RentalManagerPropertyConditionWebApiHandler_getItemAttributes = (
  getParams: GetItemAttributesParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetItemAttributesParams, never, GetPropertyItemAttributesResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getItemAttributes_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getItemImages_Path =
  '/api/web/v1/users/propertyCondition/getItemImages';

export const RentalManagerPropertyConditionWebApiHandler_getItemImages = (
  getParams: GetItemImagesParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetItemImagesParams, never, GetItemImagesResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getItemImages_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getLeases_Path =
  '/api/web/v1/users/propertyCondition/getLeases';

export const RentalManagerPropertyConditionWebApiHandler_getLeases = (
  getParams: GetLeasesParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetLeasesParams, never, GetLeasesResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getLeases_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getListingAddress_Path =
  '/api/web/v1/users/propertyCondition/getListingAddress';

export const RentalManagerPropertyConditionWebApiHandler_getListingAddress = (
  getParams: GetListingAddressParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetListingAddressParams, never, GetListingAddressResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getListingAddress_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getNotedConditions_Path =
  '/api/web/v1/users/propertyCondition/getNotedConditions';

export const RentalManagerPropertyConditionWebApiHandler_getNotedConditions = (
  getParams: GetNotedConditionsParams,
  postData: GetNotedConditionRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetNotedConditionsParams, GetNotedConditionRequestDto, GetNotedConditionsResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getNotedConditions_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyComponentItem_Path =
  '/api/web/v1/users/propertyCondition/getPropertyComponentItem';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyComponentItem = (
  getParams: GetPropertyComponentItemParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetPropertyComponentItemParams, never, GetPropertyItemResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyComponentItem_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyComponentQuantity_Path =
  '/api/web/v1/users/propertyCondition/getPropertyComponentQuantity';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyComponentQuantity = (
  getParams: GetPropertyComponentQuantityParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetPropertyComponentQuantityParams, never, GetPropertyComponentQuantityResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyComponentQuantity_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyComponentsForPropertyCondition_Path =
  '/api/web/v1/users/propertyCondition/getPropertyComponentsForPropertyCondition';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyComponentsForPropertyCondition = (
  getParams: GetPropertyComponentsForPropertyConditionParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetPropertyComponentsForPropertyConditionParams, never, GetPropertyComponentsResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyComponentsForPropertyCondition_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyCondition_Path =
  '/api/web/v1/users/propertyCondition/getPropertyCondition';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyCondition = (
  getParams: GetPropertyConditionParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetPropertyConditionParams, never, GetPropertyConditionResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyCondition_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionAssociations_Path =
  '/api/web/v1/users/propertyCondition/getPropertyConditionAssociations';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionAssociations = (
  getParams: GetPropertyConditionAssociationsParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetPropertyConditionAssociationsParams, never, GetPropertyConditionAssociationsResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyConditionAssociations_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionDocumentPreview_Path =
  '/api/web/v1/users/propertyCondition/getPropertyConditionDocumentPreview';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionDocumentPreview = (
  getParams: GetPropertyConditionDocumentPreviewParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<
    GetPropertyConditionDocumentPreviewParams,
    never,
    PropertyConditionDocumentPreviewResponseDto
  >({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyConditionDocumentPreview_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionFeatureFlags_Path =
  '/api/web/v1/users/propertyCondition/getPropertyConditionFeatureFlags';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionFeatureFlags = (
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, never, GetPropertyConditionFeatureFlagsResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyConditionFeatureFlags_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionFields_Path =
  '/api/web/v1/users/propertyCondition/getPropertyConditionFields';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionFields = (
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, never, GetPropertyConditionFieldsResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyConditionFields_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionFieldsData_Path =
  '/api/web/v1/users/propertyCondition/getPropertyConditionFieldsData';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionFieldsData = (
  getParams: GetPropertyConditionFieldsDataParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetPropertyConditionFieldsDataParams, never, GetPropertyConditionFieldsDataResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyConditionFieldsData_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditions_Path =
  '/api/web/v1/users/propertyCondition/getPropertyConditions';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditions = (
  getParams: GetPropertyConditionsParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetPropertyConditionsParams, never, GetPropertyConditionsResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyConditions_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionUserAcceptances_Path =
  '/api/web/v1/users/propertyCondition/getPropertyConditionUserAcceptances';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionUserAcceptances = (
  getParams: GetPropertyConditionUserAcceptancesParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<
    GetPropertyConditionUserAcceptancesParams,
    never,
    PropertyConditionUserAcceptancesResponseDto
  >({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyConditionUserAcceptances_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionUsers_Path =
  '/api/web/v1/users/propertyCondition/getPropertyConditionUsers';

export const RentalManagerPropertyConditionWebApiHandler_getPropertyConditionUsers = (
  getParams: GetPropertyConditionUsersParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetPropertyConditionUsersParams, never, PropertyConditionUsersResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getPropertyConditionUsers_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_getUploadToken_Path =
  '/api/web/v1/users/propertyCondition/getUploadToken';

export const RentalManagerPropertyConditionWebApiHandler_getUploadToken = (
  getParams: GetUploadTokenParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<GetUploadTokenParams, never, GetItemUploadTokenResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_getUploadToken_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_markAsSigned_Path =
  '/api/web/v1/users/propertyCondition/markAsSigned';

export const RentalManagerPropertyConditionWebApiHandler_markAsSigned = (
  getParams: MarkAsSignedParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<MarkAsSignedParams, never, PropertyConditionEmptyResponse>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_markAsSigned_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_markItemsCondition_Path =
  '/api/web/v1/users/propertyCondition/markItemsCondition';

export const RentalManagerPropertyConditionWebApiHandler_markItemsCondition = (
  getParams: MarkItemsConditionParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<MarkItemsConditionParams, never, GetPropertyItemsResponseDto>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_markItemsCondition_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_removeItemImage_Path =
  '/api/web/v1/users/propertyCondition/removeItemImage';

export const RentalManagerPropertyConditionWebApiHandler_removeItemImage = (
  getParams: RemoveItemImageParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<RemoveItemImageParams, never, PropertyConditionEmptyResponse>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_removeItemImage_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_removePropertyConditionAssociation_Path =
  '/api/web/v1/users/propertyCondition/removePropertyConditionAssociation';

export const RentalManagerPropertyConditionWebApiHandler_removePropertyConditionAssociation = (
  getParams: RemovePropertyConditionAssociationParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<RemovePropertyConditionAssociationParams, never, PropertyConditionEmptyResponse>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_removePropertyConditionAssociation_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_removePropertyConditionUser_Path =
  '/api/web/v1/users/propertyCondition/removePropertyConditionUser';

export const RentalManagerPropertyConditionWebApiHandler_removePropertyConditionUser = (
  getParams: RemovePropertyConditionUserParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<RemovePropertyConditionUserParams, never, PropertyConditionEmptyResponse>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_removePropertyConditionUser_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_removePropertyItem_Path =
  '/api/web/v1/users/propertyCondition/removePropertyItem';

export const RentalManagerPropertyConditionWebApiHandler_removePropertyItem = (
  getParams: RemovePropertyItemParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<RemovePropertyItemParams, never, PropertyConditionEmptyResponse>({
    getParams: getParams,
    endpoint: RentalManagerPropertyConditionWebApiHandler_removePropertyItem_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_sendForSigning_Path =
  '/api/web/v1/users/propertyCondition/sendForSigning';

export const RentalManagerPropertyConditionWebApiHandler_sendForSigning = (
  postData: SendForSigningRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, SendForSigningRequestDto, PropertyConditionEmptyResponse>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_sendForSigning_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_storeItemEntities_Path =
  '/api/web/v1/users/propertyCondition/storeItemEntities';

export const RentalManagerPropertyConditionWebApiHandler_storeItemEntities = (
  postData: StoreItemEntitiesRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, StoreItemEntitiesRequestDto, GetPropertyItemEntitiesResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_storeItemEntities_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyComponentQuantity_Path =
  '/api/web/v1/users/propertyCondition/updatePropertyComponentQuantity';

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyComponentQuantity = (
  postData: UpdatePropertyComponentQuantityRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, UpdatePropertyComponentQuantityRequestDto, GetPropertyComponentQuantityResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_updatePropertyComponentQuantity_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyCondition_Path =
  '/api/web/v1/users/propertyCondition/updatePropertyCondition';

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyCondition = (
  postData: UpdatePropertyConditionRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, UpdatePropertyConditionRequestDto, GetPropertyConditionResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_updatePropertyCondition_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyConditionFieldData_Path =
  '/api/web/v1/users/propertyCondition/updatePropertyConditionFieldData';

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyConditionFieldData = (
  postData: UpdatePropertyConditionFieldDataRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, UpdatePropertyConditionFieldDataRequestDto, PropertyConditionFieldDataDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_updatePropertyConditionFieldData_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyConditionUserAcceptances_Path =
  '/api/web/v1/users/propertyCondition/updatePropertyConditionUserAcceptances';

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyConditionUserAcceptances = (
  postData: UpdatePropertyConditionUserAcceptancesRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<
    never,
    UpdatePropertyConditionUserAcceptancesRequestDto,
    PropertyConditionUserAcceptancesResponseDto
  >({
    endpoint: RentalManagerPropertyConditionWebApiHandler_updatePropertyConditionUserAcceptances_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyConditionUsers_Path =
  '/api/web/v1/users/propertyCondition/updatePropertyConditionUsers';

export const RentalManagerPropertyConditionWebApiHandler_updatePropertyConditionUsers = (
  postData: UpdatePropertyConditionUsersRequestDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, UpdatePropertyConditionUsersRequestDto, PropertyConditionUsersResponseDto>({
    endpoint: RentalManagerPropertyConditionWebApiHandler_updatePropertyConditionUsers_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};
